const Types = {
  GET_ZONES_SUCCESS: "GET_ZONES_SUCCESS",
  GET_ZONE_DETAILS_SUCCESS: "GET_ZONE_DETAILS_SUCCESS",
  ZONES_LOADING: "ZONES_LOADING",
  GET_SCROLL_ZONES_SUCCESS: "GET_SCROLL_ZONES_SUCCESS",
};

export default Types;
